import { Controller } from "@hotwired/stimulus"

// Submits the controller's form element in response to an action, e.g. change->auto-submit#submit on a <select>.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
